import { ReactNode } from 'react';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="site-body">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}
